// Blog Engine M14 · Phase H Wave 1 · API client (additive, zero-touch).
// Endpoints vivono sotto /api/blog/m14/phase-h/*. Supporta header
// X-Tenant-Override per super-admin override.
const RAW_BASE = process.env.REACT_APP_BACKEND_URL || "";
const API_BASE_H = `${RAW_BASE.replace(/\/+$/, "")}/api/blog/m14/phase-h`;

const STORAGE_KEY = "m14_phase_h_super_admin_override";

export function readOverrideState() {
    try {
        const raw = window.localStorage.getItem(STORAGE_KEY);
        if (!raw) return { mode: "self", target_tenant_id: null };
        const parsed = JSON.parse(raw);
        if (!parsed || !parsed.mode) return { mode: "self", target_tenant_id: null };
        return {
            mode: parsed.mode,
            target_tenant_id: parsed.target_tenant_id || null,
        };
    } catch (_e) {
        return { mode: "self", target_tenant_id: null };
    }
}

export function writeOverrideState(state) {
    try {
        window.localStorage.setItem(STORAGE_KEY, JSON.stringify(state || {}));
    } catch (_e) { /* best-effort */ }
}

function _buildQs(params = {}) {
    const qs = new URLSearchParams();
    Object.entries(params).forEach(([k, v]) => {
        if (v === undefined || v === null || v === "") return;
        qs.set(k, String(v));
    });
    return qs.toString();
}

function _headersWithOverride() {
    const state = readOverrideState();
    const headers = {};
    if (state.mode === "specific" && state.target_tenant_id) {
        headers["X-Tenant-Override"] = state.target_tenant_id;
    }
    return headers;
}

async function _req(method, path, { params, body, skipOverride = false } = {}) {
    let url = API_BASE_H + path;
    const extraParams = { ...(params || {}) };
    // Modalità "all" → aggiunge ?all_tenants=true (meccanismo SEALED Phase D).
    const state = readOverrideState();
    if (!skipOverride && state.mode === "all") {
        extraParams.all_tenants = "true";
    }
    const qs = _buildQs(extraParams);
    if (qs) url += `?${qs}`;
    const resp = await fetch(url, {
        method,
        credentials: "include",
        headers: {
            ...(skipOverride ? {} : _headersWithOverride()),
            ...(body ? { "Content-Type": "application/json" } : {}),
        },
        body: body ? JSON.stringify(body) : undefined,
    });
    if (!resp.ok) {
        let err;
        try { err = await resp.json(); } catch { err = { detail: resp.statusText }; }
        const e = new Error(
            typeof err.detail === "string"
                ? err.detail
                : (err.detail?.error || resp.statusText),
        );
        e.status = resp.status;
        e.data = err;
        throw e;
    }
    if (resp.status === 204) return null;
    return resp.json();
}

export const adminBlogM14PhaseHApi = {
    me: () => _req("GET", "/me", { skipOverride: true }),
    tenantsAvailable: () => _req("GET", "/tenants/available", { skipOverride: true }),
    dashboardSummary: (params = {}) =>
        _req("GET", "/serp/dashboard-summary", { params }),
    socialInsights: (params = {}) =>
        _req("GET", "/social/insights", { params }),
    batchRetry: (body) =>
        _req("POST", "/social/dispatch/retry/batch", { body }),
    auditTenantOverride: (body) =>
        _req("POST", "/audit/tenant-override", { body, skipOverride: true }),
};

export const PHASE_H_STORAGE_KEY = STORAGE_KEY;
